<template>
  <v-dialog 
    v-model="loading" 
    fullscreen 
    full-width
    transition="none"
  >
    <v-container 
      fluid 
      fill-height 
      class="loading-background"
    >
      <v-layout 
        justify-center 
        align-center
      >
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
      </v-layout>
    </v-container>
  </v-dialog>
</template>

<script>
export default {
  name: 'full-loading',
  data () {
    return {
      loading: false
    }
  },
  beforeMount () {
    const vm = this
    this.$bus.$on('showFullLoading', (payload) => { vm.loading = payload })
  }
}
</script>

<style scoped>
.loading-background {
  background-color: rgba(255, 255, 255, 0.4);
}
</style>



// WEBPACK FOOTER //
// src/components/FullLoading.vue